import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaCloudUploadAlt, FaTrash, FaEdit } from "react-icons/fa";
import config from "../../config";
import { ToastContainer, toast, Bounce } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import PermissionGuard from "../Guards/PermissionGuard";
import { PERMISSIONS } from "../../constants/permissions";

axios.defaults.withCredentials = true;

const VideoGallery = () => {
  const [videos, setVideos] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0); // NEW: track progress here
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const videosPerPage = 8;
  const navigate = useNavigate();

  useEffect(() => {
    fetchVideos();
  }, []);

  const fetchVideos = async (page = 1) => {
    try {
      const pageSize = videosPerPage;
      const response = await axios.get(`${config.apiBaseUrl}/api/video/GetFilteredList`, {
        params: { page, pageSize, orderBy: "uploadedAt desc" },
        headers: { "HeaderKey": config.HeaderKey },
        withCredentials: true,
      });

      
      setVideos(response.data.videos || []);
      setCurrentPage(page);
      setTotalPages(Math.ceil(response.data.totalCount / pageSize)); // or response.data.totalPages if exists
    } catch (error) {
      toast.error("Error fetching videos");
      if (error.response?.status === 401) navigate("/");
    }
  };


  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    await uploadVideo(file);
  };
  const handleDelete = (id) => {
        toast.warn(
            <div className="text-right font-custom">
                <p>آیا از حذف این فایل مطمئن هستید؟</p>
                <div className="flex justify-end gap-2 mt-2">
                    <button
                        className="bg-red-500 hover:bg-red-700 text-white px-3 py-1 rounded"
                        onClick={() => deleteVideo(id)}
                    >
                        حذف
                    </button>
                    <button
                        className="bg-gray-500 hover:bg-gray-700 text-white px-3 py-1 rounded"
                        onClick={() => toast.dismiss()}
                    >
                        انصراف
                    </button>
                </div>
            </div>,
            { autoClose: false , icon:false}
        );
    };

  const deleteVideo = async (id) => {
    try {
      const response = await axios.post(
        `${config.apiBaseUrl}/api/video/DeleteVideo`,
        id,
        {
            withCredentials: true,
            headers: {
                "Content-Type": "application/json",
                "HeaderKey": config.HeaderKey
            },
        }
      );
      toast.success(<p dir="rtl" className="font-custom">فایل با موفقیت حذف شد</p>);
      fetchVideos();
    } catch (error) {
      toast.error(<p dir="rtl" className="font-custom">خطا در برقراری ارتباط</p>);
    }
  };
  function getPagination(current, total) {
    const delta = 2;
    const range = [];
    const rangeWithDots = [];
    let l;

    for (let i = 1; i <= total; i++) {
      if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
        range.push(i);
      }
    }

    for (let i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l > 2) {
          rangeWithDots.push("...");
        }
      }
      rangeWithDots.push(i);
      l = i;
    }

    return rangeWithDots;
  }

  const uploadVideo = async (file) => {
    setUploading(true);
    setUploadProgress(0); // reset progress
    const formData = new FormData();
    formData.append("videoFile", file);

    try {
      await axios.post(`${config.fileServerUrl}/api/FileSystem/UploadVideo`, formData, {
        headers: {
          "HeaderKey":
            config.HeaderKey,
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
        onUploadProgress: (progressEvent) => {
          
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percent);
        },
      });
      toast.success(<p dir="rtl" className="font-custom">فایل با موفقیت بارگذاری شد</p>);
      fetchVideos();
    } catch (error) {
      
      if(error.response?.data==="File not supported"){
        toast.error(<p dir="rtl" className="font-custom">این فرمت از فایل مورد قبول نیست</p>);

      }else{
        toast.error(<p dir="rtl" className="font-custom">خطا در باگذاری</p>);
        console.log(error)
      }
    } finally {
      setUploading(false);
      // Optionally reset uploadProgress to 0 after some delay or immediately
      // setUploadProgress(0);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file) {
      uploadVideo(file);
    }
  };

  //const indexOfLastVideo = currentPage * videosPerPage;
  //const indexOfFirstVideo = indexOfLastVideo - videosPerPage;
  //const currentVideos = videos.slice(indexOfFirstVideo, indexOfLastVideo);
const currentVideos = videos;

  const handleEdit = (video) => {
    navigate("/dashboard/videos/edit", { state: { video } });
};

  const openFileSelector = () => {
    document.getElementById("fileInput").click();
  };

  //const totalPages = Math.ceil(videos.length / videosPerPage);

  return (
    <div className="font-custom container mx-auto p-6">
      <h2 className="text-3xl font-bold mb-6 text-center text-gray-800">
        آرشیو
      </h2>

      {/* Drag & Drop Upload Box */}
      <PermissionGuard permission={PERMISSIONS.CONTENTS_UPLOAD}>
        <div
          className="border-2 border-dashed border-gray-300 p-10 text-center cursor-pointer bg-gray-50 rounded-lg hover:bg-gray-100 transition"
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          onClick={openFileSelector}
        >
          <FaCloudUploadAlt className="text-5xl text-gray-500 mx-auto mb-3" />
          <p className="text-gray-600">
            فایل مورد نظر را اینجا رها کنید یا کلیک کنید
          </p>
          <input
            type="file"
            id="fileInput"
            className="hidden"
            accept=".mp3,.mp4,.pdf"
            onChange={handleFileUpload}
            disabled={uploading}
          />
        </div>
      </PermissionGuard>

      {/* Show progress if uploading */}
      {uploading && (
        <div className="mt-4 text-center">
          {uploadProgress == 100 ? (<p className="text-green-600">...در حال انتقال به فایل سرور</p>) : (<p className="text-green-600">...در حال آپلود</p>)}
          <div className="w-full bg-gray-200 h-2 rounded mt-2">
            <div
              className="bg-green-500 h-2 rounded"
              style={{ width: `${uploadProgress}%` }}
            />
          </div>
          <p className="text-sm mt-2">{uploadProgress}%</p>
        </div>
      )}

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 mt-8">
        {currentVideos.map((video) => (
          <div
            key={video.id}
            className="bg-white shadow-lg rounded-lg p-3 relative group transition hover:shadow-xl"
          >
            <div className="relative overflow-hidden">
              <img
                src="/videoBg.png"
                controls
                className="w-full h-40 object-cover rounded"
              />

              <PermissionGuard permission={PERMISSIONS.CONTENTS_DELETE}>
                <button
                  className="absolute top-2 right-2 text-red-600 hover:text-red-800 bg-white/70 backdrop-blur-sm rounded p-2 transition-opacity opacity-0 group-hover:opacity-100"
                  onClick={() => handleDelete(video.id)}
                >
                  <FaTrash size={16} />
                </button>
              </PermissionGuard>
              <PermissionGuard permission={PERMISSIONS.CONTENTS_UPLOAD}>
                <button
                  className="absolute top-2 left-2 text-blue-600 hover:text-blue-800 bg-white/70 backdrop-blur-sm rounded p-2 transition-opacity opacity-0 group-hover:opacity-100"
                  onClick={() => handleEdit(video)}
                >
                  <FaEdit size={16} />
                </button>
              </PermissionGuard>
            </div>
            <p className="mt-2 text-sm text-center text-gray-700 font-semibold truncate">
              {video.name}
            </p>
          </div>
        ))}
      </div>

      {totalPages > 1 && (
        <div className="flex flex-wrap justify-center mt-6 space-x-1 rtl:space-x-reverse">
          {getPagination(currentPage, totalPages).map((item, index) => (
            <button
              key={index}
              disabled={item === '...'}
              onClick={() => typeof item === 'number' && fetchVideos(item)}
              className={`mx-1 px-3 py-1 rounded ${item === currentPage
                  ? "bg-blue-500 text-white"
                  : item === "..."
                    ? "bg-transparent cursor-default text-gray-400"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                } transition`}
            >
              {item}
            </button>
          ))}
        </div>
      )}

      <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                className={"font-custom text-center rtl"}
                pauseOnHover
                theme="dark"
                transition={Bounce}
            />
    </div>
  );
};

export default VideoGallery;
